import { useState } from 'react';
import { Card, Select } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { firmsApi } from '../api/firms';
import type { Firm } from '../types';
import { FirmLogsPanel } from '../components/firm/FirmLogsPanel';

export function AgentLogs() {
  const [selectedFirmId, setSelectedFirmId] = useState<number | null>(null);
  const { data: firms = [] } = useQuery({ queryKey: ['firms'], queryFn: firmsApi.getAll });
  return (
    <div>
      <Card style={{ marginBottom: 16 }}>
        <Select
          style={{ width: 300 }}
          placeholder="Firma seçin"
          value={selectedFirmId}
          onChange={setSelectedFirmId}
          options={firms.map((f: Firm) => ({ value: f.id, label: f.name }))}
          allowClear
        />
      </Card>
      {selectedFirmId
        ? <FirmLogsPanel firmId={selectedFirmId} />
        : <Card>Logları görmek için yukarıdan bir firma seçin.</Card>}
    </div>
  );
}
